module.exports = __webpack_public_path__ + "img/PLANETE_OUI_80X30.51e421ab.png";